var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Background(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 746,
    viewBox: "0 0 1920 746",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 615.666V477.516L316.313 25.0271H507.502V467.506H589.583V615.666H507.502V745.806H336.333V615.666H0ZM348.344 213.231L180.178 467.506H348.344V213.231Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.424 370.401C673.424 255.61 695.445 165.179 739.489 99.1072C784.2 33.0357 855.938 0 954.702 0C1053.47 0 1124.87 33.0357 1168.91 99.1072C1213.62 165.179 1235.98 255.61 1235.98 370.401C1235.98 486.526 1213.62 577.625 1168.91 643.696C1124.87 709.768 1053.47 742.803 954.702 742.803C855.938 742.803 784.2 709.768 739.489 643.696C695.445 577.625 673.424 486.526 673.424 370.401ZM1067.81 370.401C1067.81 302.994 1060.47 251.272 1045.79 215.233C1031.11 178.526 1000.75 160.173 954.702 160.173C908.656 160.173 878.293 178.526 863.612 215.233C848.931 251.272 841.59 302.994 841.59 370.401C841.59 415.783 844.259 453.49 849.598 483.523C854.937 512.888 865.614 536.914 881.63 555.601C898.313 573.62 922.67 582.63 954.702 582.63C986.734 582.63 1010.76 573.62 1026.77 555.601C1043.46 536.914 1054.47 512.888 1059.81 483.523C1065.14 453.49 1067.81 415.783 1067.81 370.401Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.42 615.666V477.516L1646.73 25.0271H1837.92V467.506H1920V615.666H1837.92V745.806H1666.75V615.666H1330.42ZM1678.76 213.231L1510.6 467.506H1678.76V213.231Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 954.874,
    y1: -49.4473,
    x2: 954.874,
    y2: 841.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 954.874,
    y1: -49.4473,
    x2: 954.874,
    y2: 841.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 954.874,
    y1: -49.4473,
    x2: 954.874,
    y2: 841.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Background);
export default __webpack_public_path__ + "static/media/404_background.012521375adc187e995b5bdd08629b29.svg";
export { ForwardRef as ReactComponent };